import "../styles/register.css";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import UserController from "../services/user-controller";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { getToken } from "../utility";
import { Dropdown } from "primereact/dropdown";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import OffPlusController from "../services/offplus-controller";
import CardBank from "../components/cardbank";
import { PrimeIcons } from "primereact/api";

export default function Register(props) {
	const { t } = useTranslation();
	const localizer = t;
	const toast = useRef(null);

	const [pageType, setPageType] = useState("body");
	const [isLoading, setIsLoading] = useState(false);
	const [states, setStates] = useState([]);
	const [cities, setCities] = useState([]);
	const [families, setFamilies] = useState([]);
	//
	const [family, setFamily] = useState({
		userFamilyId: "00000000-0000-0000-0000-000000000000",
		relationship: "فرزند",
		gender: true,
		nationalId: "",
		firstName: "",
		lastName: "",
		birthDate: null,
		mobile: "",
	});
	//
	const [mobile, setMobile] = useState(false);
	const [isNonIranian, setIsNonIranian] = useState(false);
	const [nationality, setNationality] = useState("");
	const [nationalId, setNationalId] = useState("");
	const [firstName, setFirstName] = useState(null);
	const [lastName, setLastName] = useState(null);
	const [gender, setGender] = useState(false);
	const [birthDate, setBirthDate] = useState(null);
	const [stateId, setStateId] = useState(null);
	const [cityId, setCityId] = useState(null);
	const [cardNumber, setCardNumber] = useState("");
	const [canEditNationalId, setCanEditNationalId] = useState(true);
	const [hasActiveMemberShip, setHasActiveMemberShip] = useState(true);
	const [jobType, setJobType] = useState("Worker");
	const [jobTitle, setJobTitle] = useState("");

	const [errorMessage, setErrorMessage] = useState("");
	const userController = new UserController();
	const offPlusController = new OffPlusController();
	const navigate = useNavigate();

	const nationalityTypes = [
		{ value: false, text: "ایرانی" },
		{ value: true, text: "غیر ایرانی" },
	];

	const genderTypes = [
		{ value: true, text: "مرد" },
		{ value: false, text: "زن" },
	];

	const relationTypes = [
		{ value: "همسر", text: "همسر" },
		{ value: "فرزند", text: "فرزند" },
	];

	const jobTypes = [
		{ value: "Worker", text: "کارگر" },
		{ value: "Employee", text: "کارمند" },
		{ value: "Other", text: "سایر" },
	];

	useEffect(() => {
		getProfile();
	}, []);

	//> getProfile
	const getProfile = async function () {
		try {
			if (window.isBusy === true) return;
			window.isBusy = true;
			setIsLoading(true);
			setErrorMessage("");

			var profileResult = await userController.getProfile();
			if (profileResult.isSuccess === false) throw profileResult.message;
			setCardNumber(profileResult.value.cardNumber);
			setMobile(profileResult.value.mobile);
			setIsNonIranian(profileResult.value.isNonIranian);
			setNationality(profileResult.value.nationality);
			setNationalId(profileResult.value.nationalId);
			setFirstName(profileResult.value.firstName);
			setLastName(profileResult.value.lastName);
			setGender(profileResult.value.gender);
			setJobType(profileResult.value.jobType);
			setJobTitle(profileResult.value.jobTitle);

			if (profileResult.value.birthDate)
				setBirthDate(new Date(profileResult.value.birthDate));
			if (!profileResult.value.nationalId) setCanEditNationalId(true);
			else setCanEditNationalId(false);

			setHasActiveMemberShip(profileResult.value.membershipStatus === "Active");
			//
			await getStates();
			await getCities(profileResult.value.stateId);
			setCityId(profileResult.value.cityId);
			// get families
			var familiesResult = await userController.getFamilies();
			if (familiesResult.isSuccess === false) throw familiesResult.message;
			setFamilies(familiesResult.value);
			//
		} catch (error) {
			setErrorMessage(error.toString());
		}
		setIsLoading(false);
		window.isBusy = false;
	};

	//> getStates
	const getStates = async function () {
		const statesResult = await offPlusController.getActiveStates(true);
		setStates(statesResult.value);
	};

	//> getCities
	const getCities = async function (stateId) {
		setStateId(stateId);
		const citiesResult = await offPlusController.getActiveCities(stateId, true);
		setCities(citiesResult.value);
	};

	//> register
	const register = async function (showFamilyList) {
		try {
			setIsLoading(true);
			let errors = [];
			if (!nationalId) errors.push("کد ملی وارد کنید");
			if (!firstName) errors.push("نام را وارد کنید");
			if (!lastName) errors.push("نام خانوادگی را وارد کنید");
			if (!stateId) errors.push("استان را وارد کنید");
			if (!cityId) errors.push("شهر را وارد کنید");
			if (!cardNumber) errors.push("شماره کارت را وارد کنید");
			if (!jobType) errors.push("نوع شغل را وارد کنید");

			if (errors.length > 0) {
				errors.map((item) => {
					toast.current.show({
						severity: "warn",
						summary: "ثبت اطلاعات",
						detail: item,
					});
				});

				setIsLoading(false);
				return;
			}
			//
			const result = await userController.updateProfile(
				firstName,
				lastName,
				gender,
				birthDate,
				cardNumber.replace(/-/g, ""),
				isNonIranian,
				nationality,
				nationalId,
				cityId,
				jobType,
				jobTitle
			);
			if (result.isSuccess === false) throw result.message;
			if (showFamilyList === true) {
				setPageType("family-list");
				return;
			}
			//
			let returnUrl = null;
			if (window.location.href.indexOf("?") > 0)
				returnUrl = new URLSearchParams(window.location.href.split("?")[1]).get(
					"returnUrl"
				);
			if (returnUrl) {
				navigate(returnUrl, { replace: true });
			} else {
				navigate("/membership", { replace: true });
			}
		} catch (error) {
			setErrorMessage(error.toString());
		} finally {
			setIsLoading(false);
		}
	};

	//> addFamily
	const addFamily = function () {
		setPageType("family-edit");
		setFamily({
			userFamilyId: "00000000-0000-0000-0000-000000000000",
			relationship: "فرزند",
			gender: true,
			birthDate: null,
			nationalId: "",
			firstName: "",
			lastName: "",
			mobile: "",
		});
	};

	//> editFamily
	const editFamily = function (objFamily) {
		setPageType("family-edit");
		setFamily(objFamily);
	};

	//> deleteFamily
	const deleteFamily = async function (objFamily) {
		if (!window.confirm("آیا مطمئن به حذف این عضو خانواده هستید؟")) return;
		try {
			// update family
			var deleteResult = await userController.deleteFamily(
				objFamily.userFamilyId
			);
			if (deleteResult.isSuccess === false) throw deleteResult.message;
			// get families
			var familiesResult = await userController.getFamilies();
			if (familiesResult.isSuccess === false) throw familiesResult.message;
			setFamilies(familiesResult.value);
			setPageType("family-list");
			//
		} catch (error) {
			setErrorMessage(error.toString().replace(/\r\n/g, "<br />"));
		}
	};

	//> updateFamily
	const updateFamily = async function () {
		try {
			setIsLoading(true);
			setErrorMessage("");
			// update family
			var updateResult = await userController.updateFamily(
				family.userFamilyId,
				family.relationship,
				family.gender,
				family.firstName,
				family.lastName,
				family.birthDate,
				family.nationalId,
				family.mobile
			);
			if (updateResult.isSuccess === false) throw updateResult.message;
			// get families
			var familiesResult = await userController.getFamilies();
			if (familiesResult.isSuccess === false) throw familiesResult.message;
			setFamilies(familiesResult.value);
			setPageType("family-list");
			//
		} catch (error) {
			setErrorMessage(error.toString().replace(/\r\n/g, "<br />"));
		} finally {
			setIsLoading(false);
		}
	};
	//> back
	const back = function () {
		window.history.back();
	};

	//>
	if (!getToken()) {
		window.location = "/#/login?returnUrl=/register";
		return <></>;
	}
	return (
		<article className="register">
			<Toast ref={toast} />
			<div className="header">{localizer("Register information")}</div>

			{pageType === "body" && (
				<section className="body">
					<div className="col-2">
						<div className="form-item">
							<label>{localizer("Nationality")}</label>
							<Dropdown
								value={isNonIranian}
								onChange={(e) => setIsNonIranian(e.target.value)}
								options={nationalityTypes}
								disabled={canEditNationalId === false}
								optionLabel="text"
								optionValue="value"
							/>
						</div>
						<div className="form-item">
							<label>{localizer("Country")}</label>
							<InputText
								value={nationality}
								onChange={(e) => setNationality(e.target.value)}
								disabled={canEditNationalId === false}
							/>
						</div>
					</div>

					<div className="form-item">
						<label>{localizer("Mobile number")}</label>
						<InputText value={mobile} disabled className="ltr" />
					</div>

					<div className="form-item">
						<label>
							{isNonIranian === true
								? localizer("Non iranian national id")
								: localizer("National code")}
						</label>
						<InputText
							value={nationalId}
							onChange={(e) => setNationalId(e.target.value)}
							className="ltr"
							maxLength={isNonIranian === true ? 11 : 10}
							disabled={canEditNationalId === false}
							keyfilter="int"
							required
						/>
					</div>

					<div className="form-item">
						<label>{localizer("First name")}</label>
						<InputText
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
							required
						/>
					</div>

					<div className="form-item">
						<label>{localizer("Last name")}</label>
						<InputText
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
							required
						/>
					</div>

					<div className="col-2">
						<div className="form-item">
							<label>{localizer("Gender")}</label>
							<Dropdown
								value={gender}
								onChange={(e) => setGender(e.target.value)}
								options={genderTypes}
								optionLabel="text"
								optionValue="value"
								required
							/>
						</div>
						<div className="form-item">
							<label>{localizer("Birth date")}</label>
							<DatePicker
								value={birthDate}
								onChange={(value) => setBirthDate(value)}
								calendar={persian}
								locale={persian_fa}
							/>
						</div>
					</div>

					<div className="form-item">
						<label>{localizer("State")}</label>
						<Dropdown
							id="stateId"
							className="w-full"
							value={stateId}
							onChange={(e) => getCities(e.value)}
							disabled={hasActiveMemberShip === true}
							options={states}
							optionLabel="name"
							optionValue="stateId"
						/>
					</div>

					<div className="form-item">
						<label>{localizer("City")}</label>
						<Dropdown
							id="cityId"
							className="w-full"
							value={cityId}
							onChange={(e) => setCityId(e.value)}
							disabled={hasActiveMemberShip === true}
							options={cities}
							optionLabel="name"
							optionValue="cityId"
							filter
							emptyMessage="هیچ شهری پیدا نشد"
						/>
					</div>

					<div className="col-2">
						<div className="form-item">
							<label>{localizer("Job type")}</label>
							<Dropdown
								value={jobType}
								onChange={(e) => setJobType(e.target.value)}
								options={jobTypes}
								optionLabel="text"
								optionValue="value"
								required
							/>
						</div>
						<div className="form-item">
							<label>{localizer("Job title")}</label>
							<InputText
								value={jobTitle}
								onChange={(e) => setJobTitle(e.target.value)}
								required
							/>
						</div>
					</div>

					<div className="form-item">
						<label>{localizer("Card number")}</label>
						<CardBank
							cardValue={cardNumber}
							cardOwnerName={firstName + " " + lastName}
							onChange={(e) => setCardNumber(e.value)}
						/>
					</div>

					<Button
						label="ثبت اطلاعات خانواده"
						severity="secondary"
						onClick={() => register(true)}
						loading={isLoading}
					/>

					<Button
						label={localizer("Register information")}
						onClick={() => register()}
						loading={isLoading}
					/>
					<Button label="انصراف" onClick={() => back()} severity="danger" />
				</section>
			)}

			{pageType === "family-list" && (
				<>
					<p>
						برای استفاده سایر اعضای خانواده از امکانات سامانه ، لطفا اطلاعات
						مربوط به آن ها را وارد کنید
					</p>
					<ul className="family-list">
						{families.map((item) => (
							<li>
								<button onClick={() => editFamily(item)}>
									<i className={PrimeIcons.USER_EDIT}></i>
								</button>
								<div>
									<h2>{item.relationship}</h2>
									<p>{item.firstName + " " + item.lastName}</p>
								</div>
								<button onClick={() => deleteFamily(item)}>
									<i className={PrimeIcons.TRASH}></i>
								</button>
							</li>
						))}
					</ul>
					<Button
						label="ثبت عضو جدید"
						onClick={() => addFamily()}
						loading={isLoading}
					/>
					<Button
						label="انصراف"
						onClick={() => setPageType("body")}
						severity="danger"
					/>
				</>
			)}

			{pageType === "family-edit" && (
				<>
					<section>
						<div className="family">
							<div>
								<div className="f-item">
									<label>نسبت</label>
									<Dropdown
										className="w-full"
										value={family.relationship}
										onChange={(e) =>
											setFamily({ ...family, relationship: e.value })
										}
										options={relationTypes}
										optionLabel="text"
										optionValue="value"
									/>
								</div>
								<div className="f-item">
									<label>جنسیت</label>
									<Dropdown
										className="w-full"
										value={family.gender}
										onChange={(e) => setFamily({ ...family, gender: e.value })}
										options={genderTypes}
										optionLabel="text"
										optionValue="value"
									/>
								</div>
							</div>

							<div className="col-full">
								<div className="f-item">
									<label>کد ملی</label>
									<InputText
										value={family.nationalId}
										onChange={(e) =>
											setFamily({ ...family, nationalId: e.target.value })
										}
										required
									/>
								</div>
							</div>
							<div>
								<div className="f-item">
									<label>نام</label>
									<InputText
										value={family.firstName}
										onChange={(e) =>
											setFamily({ ...family, firstName: e.target.value })
										}
										required
									/>
								</div>
								<div className="f-item">
									<label>نام خانوادگی</label>
									<InputText
										value={family.lastName}
										onChange={(e) =>
											setFamily({ ...family, lastName: e.target.value })
										}
										required
									/>
								</div>
							</div>

							<div>
								<div className="f-item">
									<label>موبایل</label>
									<InputText
										value={family.mobile}
										onChange={(e) =>
											setFamily({ ...family, mobile: e.target.value })
										}
										required
									/>
								</div>
								<div className="f-item">
									<label>تاریخ تولد</label>
									<DatePicker
										value={family.birthDate}
										onChange={(value) =>
											setFamily({ ...family, birthDate: value })
										}
										calendar={persian}
										locale={persian_fa}
									/>
								</div>
							</div>
						</div>

						<Button
							label={localizer("Register information")}
							onClick={() => updateFamily()}
							loading={isLoading}
						/>
						<Button
							label="انصراف"
							onClick={() => setPageType("family-list")}
							severity="danger"
						/>
					</section>
				</>
			)}
			<div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
		</article>
	);
}
